import { LocationDescriptor, Location } from "history";
import toaster from "@saleshandy/designs/lib/toaster";
import { getToken, removeToken, setToken } from "./token";
import { resetState } from "./reset-state";
import { redirectWithoutRefresh } from "./redirect";
import history from "../history";
// eslint-disable-next-line import/no-cycle
import api from "../../api";

export type LoginOptions = {
  redirect?: boolean;
  token: string;
};

export type LogoutOptions = {
  redirect?: boolean;
  fallbackTo?: LocationDescriptor;
};

type FallbackUrlState = {
  from: LocationDescriptor;
};

const deleteTokenAndRedirect = ({
  redirect = true,
  fallbackTo,
}: LogoutOptions = {}) => {
  removeToken();
  resetState();

  if (redirect) {
    redirectWithoutRefresh<FallbackUrlState>({
      pathname: "/login",
      state: { from: fallbackTo },
    });
  }
};

export class AuthHelper {
  static get isAuthenticated(): boolean {
    const isTokenPresent = !!getToken();
    if (isTokenPresent) {
      return isTokenPresent;
    }
    const token = new URLSearchParams(window.location.search).get("token");
    if (token) {
      setToken(token);
      return true;
    }
    return false;
  }

  static login({ redirect = true, token }: LoginOptions) {
    setToken(token);

    if (redirect) {
      const location = (history.location as Location<FallbackUrlState>).state
        ?.from || { pathname: "/clients" };
      redirectWithoutRefresh(location);
    }
  }

  static async logout({ redirect = true, fallbackTo }: LogoutOptions = {}) {
    if (getToken()) {
      api
        .get("/agency/auth/logout", {
          headers: { authorization: `Bearer ${getToken()}` },
        })
        .then(() => {
          toaster.success("Successfully logged out!");
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("Session expired");
        });
    }

    deleteTokenAndRedirect({ redirect, fallbackTo });
  }
}
